type Currencies = 'USD' | 'CAD';

export const currencyFormat = (value: number, decimals = 0, currency: Currencies = 'USD') =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: decimals,
    }).format(value);
